
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/custom-api-integration",
      function () {
        return require("private-next-pages/custom-api-integration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/custom-api-integration"])
      });
    }
  